import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { EvaluationReport } from "@/schema/console/evaluation-reports/EvaluationReport";
import AssessmentInfoPanel from "@/src/console/(auth)/_components/AssessmentResultDialog/AssessmentInfoPanel";
import CategoryDetailPanel from "@/src/console/(auth)/_components/AssessmentResultDialog/CategoryDetailPanel";
import Header from "@/src/console/(auth)/_components/AssessmentResultDialog/Header";
import Sidebar from "@/src/console/(auth)/_components/AssessmentResultDialog/Sidebar";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface AssessmentCheckResultDialogProps {
  evaluationReport: EvaluationReport;
}

interface SidebarItem {
  selected?: boolean;
  isHeader?: boolean;
  data?: {
    content: string;
    subCategoryCount: number;
    id: number;
  };
  onClick?: () => void;
}

function AssessmentResultDialog({
  evaluationReport,
}: AssessmentCheckResultDialogProps) {
  const [showCategoryDetail, setShowCategoryDetail] = useState(false);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  const {
    answer_categories,
    company,
    company_document_files,
    submitted_at,
    submitted_by,
  } = evaluationReport;

  const categories: SidebarItem[] = answer_categories.map(
    ({ id, content, answer_sub_categories }) => ({
      data: {
        content,
        subCategoryCount: answer_sub_categories.length,
        id,
      },
    }),
  );

  const sidebarItems = (
    [
      {
        isHeader: true,
      },
    ] as SidebarItem[]
  ).concat(categories);
  const { t } = useTranslation();
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="secondary">{t("view-assessment")}</Button>
      </DialogTrigger>
      <DialogContent className="min-w-[960px]">
        <DialogHeader>
          <DialogTitle>{t("assessment-check-result")}</DialogTitle>
        </DialogHeader>
        <ScrollArea
          style={{
            height: "calc(100vh - 96px)",
          }}
        >
          <div className=" bg-white">
            <Header />
            <div className=" flex flex-row">
              <Sidebar
                onAccessmentInfoSelect={() => {
                  setShowCategoryDetail(false);
                }}
                onCategorySelect={(id?: number) => {
                  if (!id) return;
                  const index = answer_categories.findIndex(
                    (category) => category.id === id,
                  );
                  setSelectedCategoryIndex(index);
                  setShowCategoryDetail(true);
                }}
                items={sidebarItems}
              />
              <div className=" flex-col flex-grow bg-cool-gray-50 px-4 py-6">
                {showCategoryDetail ? (
                  <CategoryDetailPanel
                    key={selectedCategoryIndex}
                    category={answer_categories[selectedCategoryIndex]}
                  />
                ) : (
                  <AssessmentInfoPanel
                    company={company}
                    documents={company_document_files}
                    submittedAt={submitted_at}
                    submittedBy={submitted_by ?? "---"}
                  />
                )}
              </div>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}

export default AssessmentResultDialog;
